// extracted by mini-css-extract-plugin
export default {"panel-view":"awfejkmObs","panelView":"awfejkmObs","menu":"G6O6hCzpQA","panel-view-menu-item":"pqb2mmHc13","panelViewMenuItem":"pqb2mmHc13","link":"c0QlL3ZEvu","active":"gM8bjX0atB"};